// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import eruda from 'eruda'
import Vant from 'vant';
import 'vant/lib/index.css';
import {
  Swipe,
  SwipeItem
} from 'vant';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Swipe);
Vue.use(SwipeItem);

Viewer.setDefaults({
  Options: {
    "inline": true,
    "button": true,
    "navbar": true,
    "title": true,
    "toolbar": true,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
    "url": "data-source"
  }
});


import axios from 'axios'
import api from './assets/api.js'
import http from './assets/http.js'
import * as filters from '@/assets/filter.js'
import Layer from 'vue-layer';
import 'vue-layer/lib/vue-layer.css';

import AOS from 'aos'
import 'aos/dist/aos.css'
import tool from './assets/tool.js'
tool(Vue)

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)



AOS.init();
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})



Vue.use(Vant);
Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.prototype.$http = http
Vue.prototype.$layer = Layer(Vue, {
  msgtime: 2
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js